<template>
  <div>
    <div class="modal fade" id="modal-remito_individual">
      <div class="modal-dialog modal-md">
        <div class="modal-content">
          <div class="modal-header bg-geogo-top-left pt-2 pb-2">
            <h4 class="modal-title text-white">Remito Individual</h4>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Close"
              ref="closeModal"
              id="close-modal"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="form-group col-md-6">
                <label>Dígito Verificación</label>
                <input
                  type="text"
                  class="form-control form-control-sm"
                  id="dv"
                  placeholder="Dígito Verificación"
                  v-model="form.digito_verificacion"
                  maxlength="2"
                />
              </div>
              <div class="form-group col-md-6">
                <label>Número De Remito</label>
                <input
                  type="text"
                  class="form-control form-control-sm"
                  id="num_remito"
                  placeholder="Número Remito"
                  v-model="form.numero"
                  :class="$v.form.numero.$invalid ? 'is-invalid' : 'is-valid'"
                />
              </div>
              <div class="form-group col-md-6">
                <label>Estado</label>
                <select
                  class="form-control form-control-sm"
                  v-model="form.estado"
                  :class="$v.form.estado.$invalid ? 'is-invalid' : 'is-valid'"
                  disabled
                >
                  <option value="">Seleccione...</option>
                  <option
                    v-for="estado in estados"
                    :key="estado.numeracion"
                    :value="estado.numeracion"
                  >
                    {{ estado.descripcion }}
                  </option>
                </select>
              </div>
              <div class="form-group col-md-6">
                <label>Tipo Empresa</label>
                <select
                  class="form-control form-control-sm"
                  v-model="form.tipo_empresa"
                  :class="
                    $v.form.tipo_empresa.$invalid ? 'is-invalid' : 'is-valid'
                  "
                >
                  <option value="">Seleccione...</option>
                  <option
                    v-for="tip in tipoEmpresas"
                    :key="tip.numeracion"
                    :value="tip.numeracion"
                  >
                    {{ tip.descripcion }}
                  </option>
                </select>
              </div>
              <div class="form-group col-md-6">
                <label for="sitio_id">Isla</label>
                <v-select
                  :class="$store.getters.getDarkMode ? 'dark-vselect' : ''"
                  v-model="form.sitio_id"
                  :reduce="(isla) => isla.id"
                  label="nombre"
                  :options="islas"
                  placeholder="Isla"
                  @search="buscarIslas"
                ></v-select>
              </div>
            </div>
          </div>
          <div class="modal-footer justify-content-between">
            <button
              type="button"
              class="btn btn-primary"
              v-show="!$v.form.$invalid"
              @click="save()"
            >
              Guardar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import vSelect from "vue-select";
import { required } from "vuelidate/lib/validators";

export default {
  name: "RemitoIndividual",
  components: {
    vSelect,
  },
  data() {
    return {
      form: {
        numero: null,
        digito_verificacion: null,
        estado: 1,
        tipo_empresa: null,
        sitio_id: null,
      },
      islas: [],
    };
  },
  computed: {
    estados() {
      return this.$parent.listasForms.estados || [];
    },
    tipoEmpresas() {
      return this.$parent.listasForms.tipoEmpresas || [];
    },
  },
  validations: {
    form: {
      numero: {
        required,
      },
      estado: {
        required,
      },
      tipo_empresa: {
        required,
      },
    },
  },
  methods: {
    resetForm() {
      this.islas = [];
      this.form = {
        numero: null,
        digito_verificacion: null,
        estado: 1,
        tipo_empresa: null,
        sitio_id: null,
      };
    },

    buscarIslas(search, loading) {
      if (search != "") {
        let self = this;
        loading(true);
        var url = "/api/argentina/sitios/lista?nombre=" + search;
        axios
          .get(url, {
            params: {
              pais_id: 3,
            },
          })
          .then((response) => {
            self.islas = response.data;
            loading(false);
          })
          .catch((error) => {
            self.$swal({
              icon: "error",
              title: "Ocurrió un error" + error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
            loading(false);
          });
      }
    },

    save() {
      // Validar que el número de remito no esté vacío
      if (!this.form.numero || this.form.numero.toString().trim() === "") {
        this.$swal({
          icon: "warning",
          title: "Por favor ingrese el número de remito",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
        return;
      }

      let me = this;
      this.$parent.cargando = true;
      axios
        .post("/api/argentina/remitos", this.form)
        .then(async (response) => {
          this.$parent.cargando = false;
          this.$refs.closeModal.click();
          await this.$parent.getIndex();
          await this.$parent.getGrafica();
          this.resetForm();
          this.$swal({
            icon: "success",
            title: response.data.msg || "El remito se creó exitosamente...",
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        })
        .catch((e) => {
          this.$parent.cargando = false;
          let res = Object.assign({}, e);
          let errorMsg = "Ocurrió un error, vuelva a intentarlo...";

          // Manejar errores de validación
          if (res.response?.data?.errors) {
            const errors = Object.values(res.response.data.errors).flat();
            errorMsg = errors.join(", ");
          } else if (res.response?.data?.msg) {
            errorMsg = res.response.data.msg;
          } else if (res.response?.data?.message) {
            errorMsg = res.response.data.message;
          }

          this.$swal({
            icon: "error",
            title: errorMsg,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 4000,
            timerProgressBar: true,
          });
        });
    },
  },
};
</script>
